// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App shell layout — sidebar rail + slim top bar + fluid content.
   Replaces the old stacked header/nav. See docs/frontend/DESIGN_REDESIGN.md §6.1. */
.app-shell {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-height: 100vh;
}

/* Fixed dev banner sits above everything — push the shell down to clear it. */
.app-shell--with-dev-banner {
  padding-top: 46px;
}

.app-shell-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Fluid content area — much wider than the old centered 1600px container. */
.app-content {
  flex: 1 1;
  width: 100%;
  max-width: 1760px;
  margin: 0 auto;
  padding: var(--space-lg);
  animation: fadeIn var(--transition-base);
}

@media (max-width: 768px) {
  .app-content {
    padding: var(--space-md);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/shell.css"],"names":[],"mappings":"AAAA;oFACoF;AACpF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,8EAA8E;AAC9E;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,SAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* App shell layout — sidebar rail + slim top bar + fluid content.\n   Replaces the old stacked header/nav. See docs/frontend/DESIGN_REDESIGN.md §6.1. */\n.app-shell {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  min-height: 100vh;\n}\n\n/* Fixed dev banner sits above everything — push the shell down to clear it. */\n.app-shell--with-dev-banner {\n  padding-top: 46px;\n}\n\n.app-shell-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Fluid content area — much wider than the old centered 1600px container. */\n.app-content {\n  flex: 1;\n  width: 100%;\n  max-width: 1760px;\n  margin: 0 auto;\n  padding: var(--space-lg);\n  animation: fadeIn var(--transition-base);\n}\n\n@media (max-width: 768px) {\n  .app-content {\n    padding: var(--space-md);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
